<wiz-hgroup
  #actionContainer
  width="100%"
  height="100%"
  verticalAlign="center"
  [wizTooltip]="fullStr"
  style="padding: 3px;position: absolute;"
  class="insert clickable-widget">
  <wiz-hgroup width="100%">
    <wiz-label [wizLabel]="contentStr"
    [ngStyle]="{'color':getColor()}"
    width="100%" [wizTextBehavior]="'truncate'" wizDisableTooltip="true"></wiz-label>
  </wiz-hgroup> 
 </wiz-hgroup>
